import { Form, Row, Col, Modal, Tabs, message, Card } from 'antd';
import { useState, useMemo, useRef, useEffect,forwardRef,useImperativeHandle } from 'react';
import isEqual from 'lodash.isequal';
import moment from 'moment';
import axiosInstance from './axiosInstance';

const { TabPane } = Tabs;

function useDeepCompareMemo(value) {
    const ref = useRef();
    
    // Pokud se nový value liší od předchozího (hluboké porovnání), aktualizujeme ref.current
    if (!isEqual(value, ref.current)) {
      ref.current = value;
    }
    
    // Použití useMemo k vrácení aktuální hodnoty ref.current
    return useMemo(() => ref.current, [ref.current]);
}

function getval(form,name) {
  return form.getFieldValue(name)
}

function handleException(err,modal=true){
  let msg; //= err.response ? err.response.data.error : err.message
  if (err?.response?.data?.message) msg = err.response.data.message;
  else if (err?.response?.data?.error) msg = err.response.data.error;
  else if (err?.message) msg = err.message;
  else msg = 'Neznámá chyba';
  console.log(msg)
  if (msg.includes('DETAIL:')) msg = msg.split('DETAIL:')[0].trim();
  if (msg.includes('CONTEXT:')) msg = msg.split('CONTEXT:')[0].trim();
  if(modal)Modal.error({title: 'Chyba', content: msg}); else message.error(msg);
  //message.error(error.message);
}

async function deleteRecord(url, recid, params=null) {
  return new Promise((resolve, reject) => {	
    Modal.confirm({title: 'Smazání záznamu', content: 'Opravdu chcete smazat vybraný záznam?',
      onOk: async () => {
        try {
          const response = await axiosInstance.post(url, {recid}, params?params:{});
          message.success('Záznam byl odstraněn');
          resolve();
        } catch (err) { 
          handleException(err); 
          reject(err) 
        };
      },
      onCancel: () => { resolve(); }
    })
  })
}

function subarrays(arr, count) { 
  let oo = [];
  for (let i = 0; i < arr.length; i += count) { 
      oo.push(arr.slice(i, i + count)); 
  }
  return oo;
}

function tabitem(tabname,items,required,disabled,columns=1,gutter=16){
  return (
  <TabPane tab={tabname} key={tabname}>                  
      {formitems(items,required,disabled,columns,gutter)}
  </TabPane>
  )
}

function formitems(items,required={},disabled={},columns=1,gutter=16) {
  //console.log('formitems',required,disabled)
  let aa = subarrays(items,columns); 
  return (
      aa.map( (a,i)=>(    
          <Row gutter={gutter}>
              {a.map((e) => (
                  e ? 
                  <Col span={e.span?e.span:24/columns}>
                      {e instanceof CardItem ? e.render(required,disabled) : formitem(e,required[e.name],disabled[e.name])}
                  </Col>
                  : ''
              ))}
          </Row>
      ))     
  ) 
}

class CardItem{
  constructor(items,title) {
    this.items = items;
    this.title = title; 
  }
  render(required={},disabled={}) {
    return (
      <Card title={this.title}>
        {this.items.map((item) => (
          formitem(item, required[item.name], disabled[item.name])
        ))}
      </Card>
    );
  }
}

function formitem(item,required=false,disabled=false) {    
  //console.log('formitem',required,disabled)
  let fit = {
      //name: item.name,
      label: item.label,
      rules: (item.rules??[]).concat(item.required || required ? [{ required: true }] : []),   
      className: "compact-form-item"
  } 
  if(item.labelCol && item.wrapperCol) {
      fit.labelCol = { span: item.labelCol }; 
      fit.wrapperCol = { span: item.wrapperCol };
  }
  else if(item.span==24) { 
      fit.labelCol = { span: 4 }; 
      fit.wrapperCol = { span: 20 };
  }

  let pp = disabled ? {disabled:true}:{}
  
  return (<Form.Item  key={item.name} name={item.name} {...fit} > 
      {item.ctrl(pp)} 
  </Form.Item>)    
}

function convertDates(obj) {
  const o = { ...obj };
  for (const k in o) if (o.hasOwnProperty(k)) {
      const v = o[k];     
      if (typeof(v) === 'string' && moment(v, moment.ISO_8601, true).isValid()) o[k] = moment(v);  
  }
  return o;
} 

function FormDialog({title,width,formComponent,open,onCancel,onFinish,writeRight,...props}) {
  return ( 
    	<Modal
			title={title}
			open={open}
			onCancel={onCancel}
			footer={null}
			width={width}
			className="custom-modal"
		>
		  {formComponent( {onFinish:onFinish, onCancel:onCancel,open:open,writeRight:writeRight, ...props} ) }
    </Modal>
  );
};

const OpenDialog = forwardRef(({title,width,Component,...props},ref) => {
	const [visible, setVisible] = useState(false);	

	useImperativeHandle(ref, () => ({ 
		open(){ 
			setVisible(true)
		},
		close(){ handleCancel() },
	}));
	
	function handleCancel() {
		setVisible(false);
		if(props.onCancel) props.onCancel();
	}

	return (	 
		<Modal title={title} open={visible} onCancel={handleCancel} footer={null} width={width} className="custom-modal">
			<Component {...props.componentProps??{}}/>
		</Modal>
	);
});

async function waitRef(ref, timeout = 5000, endTimeout = 100) {
	const start = Date.now();
	
  while (!ref.current) {
		if (Date.now() - start >= timeout) throw new Error("wait for ref timeout");	
		await new Promise(resolve => setTimeout(resolve, 100));
	}
  await new Promise(resolve => setTimeout(resolve, endTimeout));
}

async function tobase64(blob) {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
          const str = reader.result.split(',')[1]; // Odstraní část "data:*/*;base64,"
          resolve(str);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
  });
}

function frombase64(base64) {
  const clean = base64.replace(/[^A-Za-z0-9+/=]/g, '');
  const binstr = atob(clean);
  const len = binstr.length
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binstr.charCodeAt(i);
  return bytes;
}

  
async function downloadFile(url,params,filename,requester=axiosInstance) {
  try {
    const response = await requester.post(url, params, { responseType: 'blob'});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([response.data],{ type: response.headers['content-type'] }));
    link.setAttribute('download', filename); 
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
    link.parentNode.removeChild(link);
    message.success('Soubor byl úspěšně stažen');
  } catch (error) {
    handleException(error)
    //console.error('Download error', error);
    //message.error('Stažení souboru se nezdařilo');
  }
}

function useHeighter(offset=0) {
	const [maxheight, setMaxheight] = useState(0);
  	useEffect(() => {
    	function handleResize(){ setMaxheight(window.innerHeight - offset) }
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => { window.removeEventListener('resize', handleResize) };
	}, []);
	return [maxheight]
}

function hextorgb(hex) {
	const s = hex.length==7? hex.substr(1,6) : hex.substr(0,6)
	return [parseInt(s.substr(0, 2),16), parseInt(s.substr(2, 2),16), parseInt(s.substr(4, 2),16)]
}

function luminance(r, g, b) {
	const a = [r, g, b].map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
	return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function getTextColor(bgcolor) {
	if(!bgcolor) return '#000000';
	const lum = luminance(...hextorgb(bgcolor));
	return lum > 0.5 ? '#000000' : '#FFFFFF';
}

function delay(ms){return new Promise(resolve => setTimeout(resolve, ms));}

export { 
  useDeepCompareMemo, 
  getval, 
  handleException, 
  subarrays, 
  tabitem, 
  CardItem,
  formitems, 
  formitem, 
  convertDates,
  FormDialog,
  OpenDialog,
  deleteRecord,
  waitRef,
  downloadFile,
  useHeighter,
  tobase64,
  getTextColor,
  frombase64,
  delay,
}
  